import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import FieldCheckbox from '@react-form-fields/material-ui/components/Checkbox';
import FormValidation from '@react-form-fields/material-ui/components/FormValidation';
import FieldText from '@react-form-fields/material-ui/components/Text';
import { theme } from 'assets/theme';
import { FormComponent, IStateForm } from 'components/Abstract/Form';
import { WithStyles } from 'decorators/withStyles';
import { statuses } from 'interfaces/file';
import React from 'react';

import { IChangeStatus } from '..';

/* eslint-disable max-lines */
interface IState
  extends IStateForm<{ statusNotice: string; invalid: boolean }> {}

interface IProps {
  opened: boolean;
  status: statuses;
  invalid?: boolean;
  onSubmit: (params: IChangeStatus) => void;
  onCancel: () => void;
  classes?: any;
}

@WithStyles({
  dialog: {
    width: '25%',
    height: '25%',
    maxWidth: '100vw',
  },
  root: {
    maxWidth: '100vw',
  },
  Fragment: {
    marginBottom: 20,
    maxWidth: '100vw',
  },
  cardActions: {
    justifyContent: 'flex-end',
  },
  textField: {
    margin: 8,
  },
  heading: {
    marginTop: 30,
    marginBottom: 20,
  },
  ImageSelector: {
    marginTop: 30,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 200,
    maxWidth: '100vw',
  },
  Card: {
    marginTop: 30,
    maxWidth: '100vw',
  },
  Paper: {
    width: 600,
    height: 500,
    maxWidth: '100vw',
  },
})
export default class StatusNoticeDialog extends FormComponent<IProps, IState> {
  private labels = {
    [statuses.APPROV]: 'Aprovação',
    [statuses.APPROV_NOTICE]: 'Aprovação com ressalva',
    [statuses.DISAPPROV]: 'Reprovação de arquivo',
  };

  componentDidUpdate() {
    const { props, state } = this;
    if (props.invalid && state.model.invalid === undefined) {
      this.setState((state) => ({
        ...state,
        model: { ...state.model, invalid: props.invalid },
      }));
    }
  }

  handleEnter = () => {};
  onSubmit = (isValid: boolean) => {
    if (!isValid) return;
    const { model } = this.state;
    this.props.onSubmit({
      status: this.props.status,
      notice: model.statusNotice,
      invalid: model.invalid,
    });
  };

  get label(): statuses {
    return this.labels[this.props.status];
  }

  render() {
    const { model } = this.state;
    const { opened, classes, onCancel, status } = this.props;
    const statusNoticeRequired = status === statuses.APPROV_NOTICE;

    return (
      <Dialog
        open={opened}
        disableBackdropClick
        disableEscapeKeyDown
        onEnter={this.handleEnter}
        fullWidth
      >
        <FormValidation onSubmit={this.onSubmit} ref={this.formValidationRef}>
          <DialogTitle>{this.label}</DialogTitle>
          <DialogContent>
            <Typography component="div" dir={theme.direction}>
              <div className={classes.field}>
                <FieldText
                  label="Observação"
                  helperText={`Digite uma explicação/observação para nova mudança de status: ${this.label}.`}
                  value={model.statusNotice}
                  multiline
                  required={statusNoticeRequired}
                  validation={`${statusNoticeRequired ? 'required' : ''}`}
                  onChange={this.updateModel(
                    (model, v) => (model.statusNotice = v)
                  )}
                />
              </div>
              {this.props.status === statuses.DISAPPROV && (
                <FieldCheckbox
                  label="Inválido"
                  checked={model.invalid}
                  onChange={this.updateModel((model, v) => (model.invalid = v))}
                />
              )}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancelar</Button>
            <Button color="secondary" type="submit">
              Continuar
            </Button>
          </DialogActions>
        </FormValidation>
      </Dialog>
    );
  }
}
